module.exports = __webpack_public_path__ + "img/symbol_krone.aa28cf0.jpg";